module.exports = __webpack_public_path__ + "img/11.7b4d6b9d.webp";